import type { Api, SessionStore } from "../api/index.js";
import type { AuthApi } from "./auth_api.js";
import type { IdentityProvider } from "./identity.js";

/**
 * Page load: try the refresh cookie before showing sign-in (CAP-3). Returns
 * true when the session was restored.
 */
export async function restoreSession(api: Pick<Api, "refresh">, session: SessionStore): Promise<boolean> {
  if (session.isAuthenticated()) return true;
  return api.refresh();
}

/**
 * Sign-out: revoke the refresh token and clear the cookie (backend), sign out
 * of Firebase, drop the in-memory access token. Local state is cleared even
 * if the network call fails, so the user is never left half signed in.
 */
export async function signOut(deps: {
  api: AuthApi;
  identity: Pick<IdentityProvider, "signOut">;
  session: SessionStore;
}): Promise<void> {
  try {
    await deps.api.signOut();
  } catch {
    // Best effort: an expired access token still ends the local session.
  }
  try {
    await deps.identity.signOut();
  } finally {
    deps.session.clear();
  }
}
